import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Switch,
  TextField,
  IconButton,
  Button,
  makeStyles,
  CircularProgress,
  Typography,
  Grid,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import StyledButton from "../../../common/models/Button";
import axios from "axios";
import { appUrl } from "../../../../utils/config";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { he } from "date-fns/locale";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: theme.spacing(2),
  },
  table: {
    backgroundColor: "#fff",
    border: "1px solid #ddd",
    width: "600px",
  },
  saveButton: {
    backgroundColor: "#EC6535",
    color: "#fff",
    borderRadius: "20px",
    // padding: "8px 24px",
    textTransform: "none",
    width: "12rem",
    fontSize: "1rem",
    fontWeight: 550,
    cursor: "pointer",
    // paddingLeft:"3rem",
    // paddingRight:"3rem",
    paddingTop: "0.35rem",
    paddingBottom: "0.35rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "5rem",
    "&:hover": {
      backgroundColor: "#993d13",
    },
  },
  backButton:{
    backgroundColor: "#707070",
    color: "#fff",
    borderRadius: "20px",
    // padding: "8px 24px",
    textTransform: "none",
    width: "12rem",
    fontSize: "1rem",
    fontWeight: 550,
    cursor: "pointer",
    // paddingLeft:"3rem",
    // paddingRight:"3rem",
    paddingTop: "0.35rem",
    paddingBottom: "0.35rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "5rem",
    "&:hover": {
      backgroundColor: "#4d4d4d",
    },
  },
  headerCell: {
    fontWeight: 600,
    color: "#333",
    backgroundColor: "#f0f0f0",
    padding: "10px 16px",
    textAlign: "left",
  },
  bodyCell: {
    padding: "10px 16px",
    textAlign: "left",
    verticalAlign: "middle",
  },
  textField: {
    "& input": {
      padding: "6px 8px",
      height: "30px",
    },
  },
  addButton: {
    marginTop: theme.spacing(2),
    backgroundColor: "#fff",
    color: "#000",
    borderRadius: "20px",
    padding: "6px 16px",
    textTransform: "none",
    fontWeight: 600,
    border: "1px solid #000",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  addIconCircle: {
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    border: "2px solid #000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: theme.spacing(1),
    fontSize: "16px",
    fontWeight: 600,
  },
  deleteIcon: {
    color: theme.palette.error.main,
  },
  switchBase: {
    "&.Mui-checked": {
      color: "#007bff",
    },
    "&.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#007bff",
    },
  },
  inlineActions: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "8px",
    gap: "4px",
  },
  iconBtn: {
    padding: "2px",
  },

  footer: {
    display: "flex",
    justifyContent: "space-between",
    width: "90%",
    marginTop: theme.spacing(4),
  },
  iconBtn: {
    padding: "4px",
  },
  inlineActions: {
    display: "flex",
    flexDirection: "column",
    marginLeft: 8,
  },

}));

const UOMTab = (props) => {
   const { addSponsorList, rowData,updateNetworkData,rowNetwork } = props;
  const classes = useStyles();
  const [uoms, setUoms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isUpdated, setIsUpdated] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");
  const [savingStates, setSavingStates] = useState({});
  const [isSaving, setIsSaving] = useState(false); // Track save & next button loading

  const dispatch = (action) => {
    if (action.type === "OPEN_BACKDROP") {
    } else if (action.type === "DESTROY_BACKDROP") {
    }
  };

      const network=addSponsorList?.data?.network || rowNetwork;
   const networkUrl=updateNetworkData?.ecosystemUrl || rowData?.networkURL;

  const fetchUOMs = async () => {
    setError(null);
    setLoading(true);
    dispatch({ type: "OPEN_BACKDROP" });

    try {
      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/fetchAllUOMs/false`;
      const response = await axios.get(url);
      const data = response?.data?.data;


      const list = data.productUOMsList || [];
      if (data?.status === true || data?.status === "true") {
        const formatted = list.map((item, index) => ({
          id: item.uomID || `ID-${index + 1}`,
          uom: item.uom || "",
          selected: !!item.activated,
          isNew: false,
          uomType: item.uomType,
        }));
        setUoms(formatted);
      } else {
        setError("Something went wrong. Please try again.");
      }
    } catch (err) {
      console.error("API Error:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
      dispatch({ type: "DESTROY_BACKDROP" });
    }
  };
  useEffect(() => {
    fetchUOMs();
  }, []);

  const saveNewUom = async () => {
    try {
      const newUoms = uoms.filter((uom) => uom.isNew); // Filter new UOMs
      if (newUoms.length === 0) {
        return;
      }

      const payload = {
        ecosystemId:addSponsorList?.data?.ecosystemId || rowData?.ecosystemId,
      sponsorId: addSponsorList?.data?.organizationId || rowData?.organizationId,
        productUOMsList: newUoms.map(({ uom, uomType, selected }) => ({
          uom: uom,
          uomType: "New",
          activated: selected,
        })),
      };

      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/addUOMs`; // Update the endpoint for UOMs
      const response = await axios.post(url, payload);
      if (response.data?.status === true) {
        fetchUOMs();
        props.setUom((prev) => !prev);
      } else {
        console.error("Failed to save new UOMs.");
      }
    } catch (error) {
      console.error("Error saving new UOMs:", error);
    }
  };

  const deleteUom = async (uom) => {
    try {
      if (uom.isNew) {
        // If the UOM is new and not yet saved, remove it from the state
        setUoms((prevUoms) => prevUoms.filter((item) => item.id !== uom.id));
      } else {
        // If the UOM is already saved, send a delete request to the API
        const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/updateUOMs`;
        const payload = {
           ecosystemId:addSponsorList?.data?.ecosystemId || rowData?.ecosystemId,
      sponsorId: addSponsorList?.data?.organizationId || rowData?.organizationId,
          productUOMsList: [
            {
              uomID: uom.id, // Use the UOM ID
              uom: uom.uom, // UOM name
              activated: uom.selected, // Activation status
              markForDelete: true, // Mark the UOM for deletion
            },
          ],
        };
        const response = await axios.post(url, payload);
        if(response.data?.status === true){
          fetchUOMs(); // Refresh the UOM list after deletion
          props.setUom((prev) => !prev);
        }
        if (response.data?.data?.status === true) {
        } else {
          console.error("Failed to delete UOM.");
        }
      }
    } catch (error) {
      console.error("Error deleting UOM:", error);
    }
  };
  const handleNextClick = async () => {
    try {
      const isAnyUomSelected = uoms.filter((uom) => uom.isUpdated);

      // if (!isAnyUomSelected.length) {
      //   setErrorMessage("Please select at least one UOM."); // Show error message
      //   return; // Exit the function
      // }
      if (!isAnyUomSelected.length) {
        props.handleNext(); // Directly move to the next tab
        return;
      }
      if (uoms.every((uom) => !uom.selected)) {
        setErrorMessage("Please enable at least one in toggle mode.");
        return;
      }
      setErrorMessage("");

      setIsSaving(true); // Start loading

      // Prepare the payload
      const payload = {
         ecosystemId:addSponsorList?.data?.ecosystemId || rowData?.ecosystemId,
      sponsorId: addSponsorList?.data?.organizationId || rowData?.organizationId,
        productUOMsList: isAnyUomSelected.map(({ id, uom, selected }) => ({
          uomID: id,
          uom: uom,
          activated: selected,
          markForDelete: false,
        })),
      };


      // Call the API
      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/updateUOMs`;
      const response = await axios.post(url, payload);

      // Log the API response for debugging

      // Handle API response
      if (response.data?.status === true || response.data?.status === "true") {
        await fetchUOMs(); // Wait for fetchUOMs to complete
        setErrorMessage(""); // Clear any previous error messages
        props.handleNext(); // Proceed to the next tab
      } else {
        console.error("Failed to update UOMs.");
        setErrorMessage("Failed to update UOMs. Please try again.");
      }
    } catch (error) {
      console.error("Error updating UOMs:", error);
      setErrorMessage(
        "An error occurred while updating UOMs. Please try again."
      );
    } finally {
      setIsSaving(false); // Stop loading
    }
  };

  const handleSaveNewUom = async (index) => {
    if (savingStates[index]) return;
    setSavingStates((prev) => ({ ...prev, [index]: true }));
    const uom = uoms[index]; // Get the UOM at the specified index
    const success = await saveNewUom(uom); // Call the save function for the UOM

    if (success) {
      // Refresh the full list from the API after a successful save
      await fetchUOMs();
    } else {
      // Handle failure (e.g., show an error message)
      console.error("Failed to save new UOM.");
    }
    setSavingStates((prev) => ({ ...prev, [index]: false }));
  };

  // const handleToggle = (index) => {
  //   const updated = [...uoms]; // Create a shallow copy of the `uoms` array
  //   updated[index].selected = !updated[index].selected; // Toggle the `selected` property of the UOM at the given index
  //   setUoms(updated); // Update the state with the modified array
  //   setIsUpdated(true); // Optional: Track changes if needed
  // };
  const handleToggle = (index) => {
    const updated = [...uoms]; // Create a shallow copy of the `uoms` array
    updated[index].selected = !updated[index].selected; // Toggle the `selected` property of the UOM at the given index
    updated[index].isUpdated = true; // Mark the UOM as changed
    setUoms(updated); // Update the state with the modified array
    setIsUpdated(true); // Optional: Track changes if needed
  };

  const handleNameChange = (index, value) => {
    const updated = [...uoms]; // Create a shallow copy of the `uoms` array
    updated[index].uom = value; // Update the `uom` property of the UOM at the given index
    setUoms(updated); // Update the state with the modified array
  };
  const handleDelete = (index) => {
    const newUoms = uoms.filter((_, i) => i !== index);
    setUoms(newUoms);
  };

  const handleAddUom = () => {
    // const nextId = (uoms.length + 1).toString().padStart(2, "0");
    setUoms([
      ...uoms,
      {
        // id: nextId,
        uom: "",
        uomType: "New",
        selected: false,
        isNew: true,
      },
    ]);
  };

  const handleCancel = (index) => {
    const updatedUoms = uoms.filter((_, i) => i !== index); // Remove the UOM at the given index
    setUoms(updatedUoms); // Update the state with the new list
  };

  return (
    <div className={classes.container}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell className={classes.headerCell}>Selection</TableCell>
            <TableCell className={classes.headerCell}>UOM</TableCell>
            <TableCell className={classes.headerCell}>UOM ID</TableCell>
            <TableCell className={classes.headerCell}>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <TableRow>
              <TableCell colSpan={4}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100px",
                  }}
                >
                  <CircularProgress />
                </div>
              </TableCell>
            </TableRow>
          ) : error ? (
            <TableRow>
              <TableCell colSpan={4}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "60px",
                    backgroundColor: "#ffecec",
                    color: "#b00020",
                    border: "1px solid #ff9999",
                  }}
                >
                  <Typography>{error}</Typography>
                </div>
              </TableCell>
            </TableRow>
          ) : (
            uoms.map((uom, index) => (
              <TableRow key={uom.id}>
                <TableCell className={classes.bodyCell}>
                  <Switch
                    checked={uom.selected}
                    onChange={() => handleToggle(index)}
                    classes={{ switchBase: classes.switchBase }}
                  />
                </TableCell>
                <TableCell className={classes.bodyCell}>
                  {uom.isNew ? (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <TextField
                        placeholder="Type Text Here"
                        value={uom.uom || ""} // Bind the `uom` property to the input field
                        onChange={(e) =>
                          handleNameChange(index, e.target.value)
                        }
                        onBlur={(e) => {
                          const trimmed = e.target.value.trim();
                          if (trimmed !== e.target.value) {
                            handleNameChange(index, trimmed);
                          }
                        }}
                        className={classes.textField}
                        variant="outlined"
                        inputProps={{
                          onBeforeInput: (e) => {
                            const allowedChars = /^[a-zA-Z]+$/;
                            if (!allowedChars.test(e.data)) {
                              e.preventDefault();
                            }
                          }
                        }}
                      />
                      <div className={classes.inlineActions}>
                        <IconButton
                          onClick={() => handleCancel(index)}
                          className={classes.iconBtn}
                        >
                          <CancelIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          onClick={() => handleSaveNewUom(index)}
                          className={classes.iconBtn}
                          disabled={
                            !uoms[index].uom?.trim() ||
                            uoms.some(
                              (item, i) =>
                                i !== index &&
                              item.uom?.trim()?.toLowerCase() === uoms[index].uom?.trim()?.toLowerCase()
                          ) || savingStates[index]
                          }
                        >
                          <SaveIcon fontSize="small" />
                        </IconButton>
                      </div>
                    </div>
                  ) : (
                    uom.uom
                  )}
                </TableCell>
                <TableCell className={classes.bodyCell}>{uom.id}</TableCell>
                <TableCell className={classes.bodyCell}>
                  {(uom.isNew === true || uom.uomType !== "Default") && (
                    <IconButton
                      aria-label="delete"
                      onClick={() => deleteUom(uom)} // Call deleteUom function
                    >
                      <DeleteIcon className={classes.deleteIcon} />
                    </IconButton>
                  )}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
      {errorMessage && (
        <div style={{ color: "red" }} className="error-message">
          {errorMessage}
        </div>
      )}
      <Button
        variant="outlined"
        onClick={handleAddUom}
        className={classes.addButton}
      >
        <span className={classes.addIconCircle}>+</span>
        Add New UOM
      </Button>

      <div className={classes.footer}>
        <Grid
          className={classes.backButton}
          onClick={() => {
            props.handleBack();
          }}
        >
          <ChevronLeftIcon />
          Back
        </Grid>
        <Grid
          className={classes.saveButton}
          onClick={() => {
            if (isUpdated) {
              handleNextClick(); // Call API and move to the next tab if updates are made
            } else {
              props.handleNext(); // Directly move to the next tab if no updates are made
            }
          }}
          style={{
            opacity: isSaving ? 0.7 : 1,
            pointerEvents: isSaving ? 'none' : 'auto' 
          }}
        >
          {isSaving ? (
            <>
              <CircularProgress size={16} color="inherit" style={{ marginRight: '8px' }} />
              Saving...
            </>
          ) : (
            <>
              Save & Next
              <ChevronRightIcon />
            </>
          )}
        </Grid>
      </div>
    </div>
  );
};

export default UOMTab;
